/* eslint-disable react/no-array-index-key, consistent-return, @typescript-eslint/no-shadow, prettier/prettier, @typescript-eslint/no-unused-vars */
import React from 'react';
import { DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';

const ConfigList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { fetchConfigKeys } = useService();

	return (
		<DataList
			fetchData={fetchConfigKeys}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.CONFIG_IMPACT}
			initialSortDirection='ASC'
			initialSortIndex={0}
		/>
	);
};

export default ConfigList;
